module.exports = __webpack_public_path__ + "static/media/Mars4.6cb08394.jpg";